import React from 'react';
import { useSettings } from '../contexts/SettingsContext';
import ChatCard from './ChatCard';

// `variant`:
// - idle: blank/neutral before user starts
// - active: primary bright (current step)
// - inactive: light (upcoming step)
// - completed: secondary bright + tick
const ProgressCard = ({ title, description, icon: Icon, variant = 'idle' }) => {
  const { settings } = useSettings();
  const primaryColor = settings.theme?.colors?.primary || '#3B5BDB';
  const secondaryColor = settings.theme?.colors?.secondary || '#20C997';

  const isIdle = variant === 'idle';
  const isActive = variant === 'active';
  const isInactive = variant === 'inactive';
  const isCompleted = variant === 'completed';

  // Determine card variant based on state
  const cardVariant = isCompleted ? 'secondary' : 'primary';

  // Colors per state for border and background
  const hexToRgba = (hex, alpha) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  const borderColor = isCompleted
    ? secondaryColor
    : isActive
    ? primaryColor
    : isInactive
    ? `${primaryColor}40`
    : `${primaryColor}20`;

  const cardBg = isCompleted
    ? `${secondaryColor}25`
    : isActive
    ? `${primaryColor}25`
    : isInactive
    ? `${primaryColor}12`
    : 'transparent';

  const opacity = isIdle ? 0.0 : isInactive ? 0.5 : 1;

  return (
    <ChatCard
      variant={cardVariant}
      size="md"
      rounded="xl"
      className="w-full relative chat_transition"
      style={{
        borderColor,
        backgroundColor: cardBg,
        opacity,
      }}
    >
      {isCompleted ? (
        <div
          className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full flex items-center justify-center chat_text_xs chat_font_bold chat_text_white"
          style={{ backgroundColor: secondaryColor }}
        >
          ✓
        </div>
      ) : null}
      <div className="flex items-center chat_gap_sm" style={{ gap: '13px' }}>
        {Icon ? (
          <div
            className="flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center"
            style={{ color: isCompleted ? secondaryColor : primaryColor }}
          >
            <Icon />
          </div>
        ) : null}

        <div className="flex-1 min-w-0">
          <h4 className="chat_heading_sm chat_font_semibold chat_mb_xs">
            {title}
          </h4>
          {description ? (
            <p className="chat_text_md text-gray-600 dark:text-gray-300 line-clamp-2">
              {description}
            </p>
          ) : null}
        </div>
      </div>
    </ChatCard>
  );
};

export default ProgressCard;

